'use es6';

import { PUBLIC_BOOK_ENDPOINT, LINK_ENDPOINT } from 'MeetingsLib/constants/endpoints';
import { hubletAwareApi } from 'MeetingsLib/utils/utils';
export function fetchMeetingsUser(httpClient, slug, includeInactiveLink) {
  return httpClient.get(PUBLIC_BOOK_ENDPOINT + "/user", {
    query: {
      includeInactiveLink: includeInactiveLink,
      slug: slug
    },
    withCredentials: false,
    api: hubletAwareApi
  });
}
export function fetchPublicAvailabilityInfo(httpClient, queryParams) {
  return httpClient.get("" + PUBLIC_BOOK_ENDPOINT, {
    withCredentials: false,
    query: queryParams,
    timeout: 12000,
    api: hubletAwareApi
  });
}
export function fetchCompanyName(httpClient, slug) {
  return httpClient.get(LINK_ENDPOINT + "/" + slug + "/company", {
    withCredentials: false,
    api: hubletAwareApi
  });
}
export function createMeeting(httpClient, queryParams, data) {
  return httpClient.post("" + PUBLIC_BOOK_ENDPOINT, {
    withCredentials: false,
    api: hubletAwareApi,
    query: queryParams,
    timeout: 30000,
    data: data
  });
}
export function fetchEventDetails(httpClient, slug, meetingChangeId) {
  return httpClient.get(PUBLIC_BOOK_ENDPOINT + "/meeting", {
    query: {
      meetingChangeId: meetingChangeId,
      slug: slug
    }
  });
}
export function cancelMeeting(httpClient, slug, meetingChangeId) {
  return httpClient.delete(PUBLIC_BOOK_ENDPOINT, {
    withCredentials: false,
    api: hubletAwareApi,
    query: {
      slug: slug,
      meetingChangeId: meetingChangeId
    },
    timeout: 30000
  });
}
export function rescheduleMeeting(httpClient, meetingRescheduleRequest) {
  return httpClient.post(PUBLIC_BOOK_ENDPOINT + "/reschedule", {
    withCredentials: false,
    api: hubletAwareApi,
    timeout: 30000,
    data: meetingRescheduleRequest
  });
}